import { Route, Navigate } from 'react-router-dom';
import { lazyWithRetry } from '../utils/lazyWithRetry';
import ProtectedRoute from '../features/auth/ProtectedRoute';
import RequireRole from '../layouts/RequireRole';
import { RiderLayout } from '../layouts/RiderLayout';

const RiderHomeView = lazyWithRetry(() => import('../features/rider/home/RiderHomeView'));
const RiderScheduleView = lazyWithRetry(() => import('../features/rider/schedule/RiderScheduleView'));
const RiderAvailabilityView = lazyWithRetry(() => import('../features/rider/profile/RiderAvailabilityView'));
const RiderProfileView = lazyWithRetry(() => import('../features/rider/profile/RiderProfileView').then(module => ({ default: module.RiderProfileView })));
const RiderPersonalDataView = lazyWithRetry(() => import('../features/rider/profile/RiderPersonalDataView').then(module => ({ default: module.RiderPersonalDataView })));
const RiderNotificationsView = lazyWithRetry(() => import('../features/rider/profile/RiderNotificationsView').then(module => ({ default: module.RiderNotificationsView })));
const RiderSecurityView = lazyWithRetry(() => import('../features/rider/profile/RiderSecurityView').then(module => ({ default: module.RiderSecurityView })));
const RiderAdvisorView = lazyWithRetry(() => import('../features/rider/advisor/RiderAdvisorView'));

export function RiderRoutes() {
    return (
        <Route path="/rider" element={
            <ProtectedRoute>
                <RequireRole allowedRoles={['rider', 'admin']}>
                    <RiderLayout />
                </RequireRole>
            </ProtectedRoute>
        }>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<RiderHomeView />} />
            <Route path="schedule" element={<RiderScheduleView />} />
            <Route path="availability" element={<RiderAvailabilityView />} />
            <Route path="profile" element={<RiderProfileView />} />
            <Route path="profile/personal" element={<RiderPersonalDataView />} />
            <Route path="profile/notifications" element={<RiderNotificationsView />} />
            <Route path="profile/security" element={<RiderSecurityView />} />
            <Route path="advisor" element={<RiderAdvisorView />} />
        </Route>
    );
}
